import { CardListingPosition } from '@hyphengroup/cms-components/cms-blocks/CardListingPosition/CardListingPosition';
import { CardListingWrapperProps } from './types';
import { usePageDataContext } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import {
  ComponentProductMetadata,
  TravelInsuranceQuotesData,
} from '$/(cms)/_modules/cmsService/types';

export const CardListingWrapperTravel: React.FC<CardListingWrapperProps> = (
  props,
) => {
  const { metadata } = props;
  const metadataProductCards = metadata?.product_card ?? [];
  const {
    pageData: { travelQuotes },
  } = usePageDataContext();

  const metadataToSend = { ...metadata };
  metadataToSend.product_card = metadataProductCards;
  const serializedMetadataToSend: ComponentProductMetadata = JSON.parse(
    JSON.stringify(metadataToSend),
  );

  const travelPremiumsData = getTravelPremiumsData(travelQuotes);

  return (
    <CardListingPosition
      {...props}
      metadata={serializedMetadataToSend}
      travelPremiumsData={travelPremiumsData}
      travelQuotes={travelQuotes}
      skeletonThreshold={travelQuotes?.status === 'inprogress' ? 3 : 0}
    />
  );
};

const createPlaceholderPremium = (code: string) => ({
  brokerProductCode: code,
  offeredPremium: '',
  originalPremium: '',
  currencySymbol: '',
});

const getTravelPremiumsData = (
  travelQuotes: TravelInsuranceQuotesData | undefined,
) => {
  let result = travelQuotes?.premiums ?? [];

  // Combine old premiums ids with current premiums to show loading state for old premiums
  if (travelQuotes?.status === 'inprogress' && travelQuotes.oldPremiumsIds) {
    const premiumsMap = new Map(result.map((x) => [x?.brokerProductCode, x]));

    const oldPremiumsSet = new Set(travelQuotes.oldPremiumsIds);

    const orderedPremiums = travelQuotes.oldPremiumsIds.map((code) => {
      return premiumsMap.get(code) ?? createPlaceholderPremium(code);
    });

    // Append new premiums that weren't in the old list
    const newPremiums = result.filter(
      (x) => !oldPremiumsSet.has(x?.brokerProductCode ?? ''),
    );

    result = [...orderedPremiums, ...newPremiums];
  }

  return result;
};
